import api from "../atlasApi";

export const serviceCheckCurvature = (data) => {
  return api.post("/horizon/check-curvature/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};
